<template>
  <div class="outer-container">
    <div style="background-color:white">
      <div class="container">
        <div class="pd">
          <div class="header">
            <h3 class="text-center header-font">
              Certificate
            </h3>
          </div>
          <div class="bg-img">
            <img class="fishes" src="../../assets/bongo/rectangle.svg" alt="" />

            <img
              class="fish"
              src="../../assets/bongo/Bongo_UI-UX 1.png"
              alt=""
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {}
</script>

<style scoped>
.outer-container {
  margin-bottom: 100px;
  padding-bottom: 100px;
}
.header-font {
  padding-top: 100px;
  font: 800 2.25rem/2.75rem 'Manrope';
  color: #29292b;
}
.bg-img {
  position: relative;
  left: 0;
  top: 0;
  bottom: 0;
  margin: 150px 0;
}
.fishes {
  position: relative;
  top: 0;
  left: auto;
  width: 100%;
  max-height: 200px;
}
.fish {
  margin: auto;
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  /* position: absolute;
      top: -130px;
      left: 350px; */
  width: 625px;
  max-height: 454px;
}

.pd {
  padding: 0 25px;
  padding-bottom: 100px;
}

@media only screen and (max-width: 600px) {
  .outer-container {
    margin-bottom: 50px;
    padding-bottom: 50px;
  }
  .bg-img {
    position: relative;
    left: 0;
    top: 0;
    margin: 100px 0;
    margin-top: 100px !important;
  }
  .fishes {
    position: relative;
    top: 0;
    left: auto;
    width: 100%;
    max-height: 200px;
  }
  .fish {
    margin: auto;
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    /* position: absolute;
      top: -130px;
      left: 350px; */
    width: 320px;
    max-height: 300px;
  }

  .pd {
    padding: 0 25px;
    padding-bottom: 25px;
  }
}
</style>
